import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useT } from "@hooks";

interface Props {
  show: boolean;
  onClose: () => void;
  title: string;
  value: string;
}
const DialogObservation = ({ show, onClose, title, value }: Props) => {
  const t = useT();
  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">{title}</span>}
      body={
        <div className="form-group">
          <label htmlFor="observation">{t("common.label.observations")}</label>
          <textarea name="observation" className="form-control" rows={3} id="textArea" value={value || "-"} disabled />
        </div>
      }
      onClose={onClose}
      showCloseButton
      useOverflow
    />
  );
};

export default DialogObservation;
